// src/components/pdf/charts/ComparisonBar.jsx
import React from 'react';
import { View, Text } from '@react-pdf/renderer';

/**
 * Barre de comparaison - Layout identique à l'app web
 */
const ComparisonBar = ({ 
  label, 
  valueLeft, 
  valueRight, 
  maxLeft, 
  maxRight, 
  showPercentage = false, 
  compact = false,
  groupMax = null
}) => {
  // Calculer les valeurs à afficher
  let displayLeft, displayRight, numValueLeft, numValueRight;
  
  if (showPercentage && maxLeft !== undefined && maxRight !== undefined) {
    numValueLeft = Math.round((valueLeft / 100) * maxLeft);
    numValueRight = Math.round((valueRight / 100) * maxRight);
    displayLeft = `${valueLeft}% (${numValueLeft}/${maxLeft})`;
    displayRight = `${valueRight}% (${numValueRight}/${maxRight})`;
    numValueLeft = valueLeft;
    numValueRight = valueRight;
  } else {
    numValueLeft = valueLeft;
    numValueRight = valueRight;
    displayLeft = valueLeft;
    displayRight = valueRight;
  }

  // Calculer les pourcentages de largeur (0-100%)
  let widthLeftPct, widthRightPct;
  
  if (showPercentage) {
    // Pour les %, base = 100
    widthLeftPct = numValueLeft;
    widthRightPct = numValueRight;
  } else if (groupMax !== null) {
    // Pour les counts, base = groupMax
    widthLeftPct = groupMax > 0 ? (numValueLeft / groupMax) * 100 : 0;
    widthRightPct = groupMax > 0 ? (numValueRight / groupMax) * 100 : 0;
  } else {
    // Fallback
    const normalizeBase = Math.max(numValueLeft, numValueRight);
    widthLeftPct = normalizeBase > 0 ? (numValueLeft / normalizeBase) * 100 : 0;
    widthRightPct = normalizeBase > 0 ? (numValueRight / normalizeBase) * 100 : 0;
  }

  const containerMargin = compact ? 6 : 8;
  const fontSize = compact ? 8 : 9;
  const barHeight = compact ? 12 : 16;

  return (
    <View style={{ 
      marginBottom: containerMargin,
      paddingHorizontal: 15
    }}>
      {/* Ligne avec étiquettes - identique à stat-row-header */}
      <View style={{ 
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: 2
      }}>
        {/* Valeur gauche - flex: 1, textAlign: left */}
        <View style={{ flex: 1 }}>
          <Text style={{ 
            fontSize, 
            color: '#1976D2', 
            fontWeight: 'bold',
            textAlign: 'left'
          }}>
            {displayLeft}
          </Text>
        </View>

        {/* Label centré - wrapper View pour forcer le centrage */}
        <View style={{ 
          minWidth: compact ? 100 : 120,
          alignItems: 'center'
        }}>
          <Text style={{ 
            fontSize: compact ? 8 : 8, 
            color: '#333',
            textAlign: 'center'
          }}>
            {label}
          </Text>
        </View>

        {/* Valeur droite - flex: 1, textAlign: right */}
        <View style={{ flex: 1 }}>
          <Text style={{ 
            fontSize, 
            color: '#FF9800', 
            fontWeight: 'bold',
            textAlign: 'right'
          }}>
            {displayRight}
          </Text>
        </View>
      </View>

      {/* Barres - identique à stat-row-bars */}
      <View style={{ 
        flexDirection: 'row',
        alignItems: 'center',
        height: barHeight
      }}>
        {/* Container gauche - flex: 1, justifyContent: flex-end */}
        <View style={{ 
          flex: 1,
          flexDirection: 'row',
          justifyContent: 'flex-end',
          alignItems: 'center',
          height: '100%'
        }}>
          {/* Barre gauche avec width en % */}
          <View style={{ 
            width: `${widthLeftPct}%`,
            height: '100%',
            backgroundColor: '#1976D2',
            borderTopLeftRadius: 4,
            borderBottomLeftRadius: 4
          }} />
        </View>

        {/* Divider central */}
        <View style={{ 
          width: 2,
          height: barHeight * 0.7,
          backgroundColor: '#666'
        }} />

        {/* Container droite - flex: 1 */}
        <View style={{ 
          flex: 1,
          flexDirection: 'row',
          alignItems: 'center',
          height: '100%'
        }}>
          {/* Barre droite avec width en % */}
          <View style={{ 
            width: `${widthRightPct}%`,
            height: '100%',
            backgroundColor: '#FF9800',
            borderTopRightRadius: 4,
            borderBottomRightRadius: 4
          }} />
        </View>
      </View>
    </View>
  );
};

export default ComparisonBar;